#import "../fragments/email-automation-status.graphql"

mutation EmailAutomationStatusUpdateField($input: EmailAutomationStatusUpdateFieldInput!) {
    emailAutomationStatusUpdateField(input: $input) {
        emailAutomationStatus {
            ...EmailAutomationStatus
        }
    }
}
